<template>
  <div class="animated fadeIn kanban-main-container">
    <div class="w-100 px-3 kanban-nav">
      <h5 class="pt-2 pl-4 text-third text-bold">
        <span class="d-md-down-none">
          <span v-if="card && card.situacao === 'GANHO'">
            <i class="fas fa-user-check"></i> &nbsp; {{ card.pessoa.nome }} |
            <strong class="text-success"
              >GANHOU <i class="fas fa-check"></i
            ></strong>
          </span>
          <span v-else-if="card && card.situacao === 'PERDIDO'">
            <i class="fas fa-heart-broken"></i> &nbsp; {{ card.pessoa.nome }} |
            <strong class="text-danger"
              >PERDIDO <i class="fas fa-times"></i
            ></strong>
          </span>
          <span
            v-else-if="card"
            :style="card && card.alreadyAssociate ? 'color:#04a892;' : ''"
          >
            <i
              class="fas fa-user-edit"
              v-if="personType == 'PF'"
            ></i>
            <i
              class="fas fa-industry"
              v-else
            ></i>
            &nbsp; {{ card.pessoa.nome }}
          </span>
        </span>
      </h5>
      <div
        class="pr-4"
        style="display: block; right: -48px; position: fixed"
      >
        <b-button
          class="btn btn-sm btn-third rounded-4"
          size="sm"
          @click="onBack"
          style="border-radius: 5px"
        >
          <i class="fas fa-long-arrow-alt-left"></i
          ><span class="d-md-down-none">&nbsp; VOLTAR</span>
        </b-button>
        <b-button
          v-if="
            card &&
            (!card.situacao || card.situacao === 'ATIVO') &&
            !boardArchived
          "
          class="btn btn-sm btn-success rounded-4 ml-2"
          size="sm"
          @click="onGain"
        >
          <i class="fas fa-user-check"></i
          ><span class="d-md-down-none">&nbsp; GANHO</span>
        </b-button>
        <b-button
          v-if="
            card &&
            (!card.situacao || card.situacao === 'ATIVO') &&
            !boardArchived
          "
          class="btn btn-sm btn-danger rounded-4 ml-2"
          size="sm"
          @click="onLost"
        >
          <i class="fas fa-user-times"></i
          ><span class="d-md-down-none">&nbsp; PERDIDO</span>
        </b-button>
        <b-button
          v-if="
            card &&
            (!card.situacao || card.situacao === 'ATIVO') &&
            !boardArchived
          "
          class="btn btn-sm btn-info rounded-4 ml-2"
          size="sm"
          @click="onFinish"
        >
          <i class="fas fa-user-slash"></i
          ><span class="d-md-down-none">&nbsp; FINALIZAR</span>
        </b-button>
        <b-button
          v-if="card && card.situacao === 'PERDIDO' && !boardArchived"
          class="btn btn-sm btn-warning rounded-4 ml-2"
          size="sm"
          @click="onReactive"
        >
          <i class="fas fa-sync-alt"></i
          ><span class="d-md-down-none">&nbsp; REATIVAR</span>
        </b-button>
        <b-button
          v-if="
            card &&
            (!card.situacao || card.situacao === 'ATIVO') &&
            !boardArchived
          "
          class="btn btn-sm btn-warning rounded-4 ml-2"
          size="sm"
          @click="onConfirmDelete"
        >
          <i class="fas fa-user-minus"></i
          ><span class="d-md-down-none">&nbsp; CANCELAR</span>
        </b-button>
        <span class="mr-5">&nbsp;</span>
      </div>
    </div>
    <div class="container-fluid">
      <RestrictionAlert
        class="mt-4"
        :personDocument="data.document"
      />
      <div class="form-group row pt-4">
        <div class="col-md-5">
          <CrmDetailsPerson
            ref="CrmDetailsPerson"
            :card="card"
            :boardArchived="boardArchived"
            v-on:Reload="onReloadFollowup"
          />
          <CrmDetailsContacts
            ref="CrmDetailsContacts"
            :card="card"
            :phones="person && person.telefone"
            :boardArchived="boardArchived"
            v-on:Reload="onReloadPersonAndFollowup"
          />
          <CrmDetailsAddress
            ref="CrmDetailsAddress"
            :card="card"
            :address="person && person.endereco"
            :boardArchived="boardArchived"
            v-on:Reload="onReloadPersonAndFollowup"
          />
          <CrmDetailsProduct
            ref="CrmDetailsProduct"
            :card="card"
            :boardArchived="boardArchived"
            v-on:Reload="onReloadFollowup"
          />
          <CrmDetailsLeadOwner
            ref="CrmDetailsLeadOwner"
            :card="card"
            :boardArchived="boardArchived"
            v-on:Reload="onReloadChangeLeadOwner"
          />
        </div>
        <div class="col-md-7">
          <div class="row h-100">
            <div class="col-md-12 h-100 d-flex flex-column">
              <CrmDetailsInfo
                ref="CrmDetailsInfo"
                :card="card"
              />
              <CrmDetailsFollowup
                v-if="!boardArchived"
                ref="CrmDetailsFollowup"
                :card="card"
                v-on:Reload="onReloadPersonAndFollowup"
              />
              <CrmDetailsObservation
                v-if="!boardArchived"
                ref="CrmDetailsObservation"
                :card="card"
                v-on:Reload="onReloadPersonAndFollowup"
              />
              <CrmDetailsTimeline
                ref="CrmDetailsTimeline"
                :card="card"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalCardDelete
      v-if="!boardArchived"
      ref="ModalCardDelete"
      v-on:Back="onBack"
    />
    <ModalCardLost
      v-if="!boardArchived"
      ref="ModalCardLost"
      v-on:Reload="onLoadLead"
    />
    <ModalCardFinish
      v-if="!boardArchived"
      ref="ModalCardFinish"
      v-on:Reload="onLoadLead"
    />
  </div>
</template>
<script>
import { JWTService } from '@/shared/services/jwt'
import { loading, toast } from '@/shared/utils/UIHelper'

import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import ModalCardDelete from '@/views/private/crm/details/modal/carddeletemodal.vue'
import ModalCardFinish from '@/views/private/crm/details/modal/finish/cardfinishmodal.vue'
import ModalCardLost from '@/views/private/crm/details/modal/lost/cardlostmodal.vue'
import RestrictionAlert from '../../../../components/UI/restrictionAlert/restrictionAlert.vue'

import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import CrmDetailsAddress from './addresses/address.vue'
import CrmDetailsContacts from './contacts/Contact.vue'
import CrmDetailsFollowup from './followup/followup.vue'
import CrmDetailsInfo from './info/info.vue'
import CrmDetailsLeadOwner from './leadowner/leadowner.vue'
import CrmDetailsObservation from './observation/observation.vue'
import CrmDetailsPerson from './person/person.vue'
import CrmDetailsProduct from './product/product.vue'
import CrmDetailsTimeline from './timeline/timeline.vue'

const cardDataModel = {
  document: null,
  boardColumnId: null,
  motivoPerdaId: null,
  origemLeadId: null,
  pessoaId: null,
  posicao: 0,
  situacao: 0,
  countReativado: 0,
  dataCriacao: null,
  dataInicioSituacao: null,
  dataReativacao: null,
  responsavel: null
}

export default {
  name: 'CrmDetails',
  data () {
    return {
      isLoaded: false,
      name: null,
      data: cardDataModel,
      card: null,
      permissions: null,
      person: null,
      history: null,
      boardArchived: false
    }
  },
  components: {
    ModalCardDelete,
    ModalCardLost,
    ModalCardFinish,
    CrmDetailsPerson,
    CrmDetailsLeadOwner,
    CrmDetailsFollowup,
    CrmDetailsObservation,
    CrmDetailsInfo,
    CrmDetailsTimeline,
    CrmDetailsContacts,
    CrmDetailsAddress,
    CrmDetailsProduct,
    RestrictionAlert
  },
  computed: {
    boardId: function () {
      return this.$route.params.boardId
    },
    backUrl: function () {
      return this.$route.params.backUrl
    },
    cardId () {
      return this.$route.params.cardId
    },
    personType: function () {
      let result = 'PF'
      if (this.card && this.card.pessoa && this.card.pessoa.tipoPessoa) {
        return this.card.pessoa.tipoPessoa
      } else {
        result = 'PF'
        if (this.card && this.card.pessoa && this.card.pessoa.document) {
          let doc = this.card.pessoa.document.replace('.', '')
          doc = doc.replace('.', '')
          doc = doc.replace('-', '')
          doc = doc.replace('/', '')

          if (doc.length > 11) {
            result = 'PJ'
          }
        }
      }
      return result
    },
    personName: function () {
      let result = ''
      if (this.card && this.card.pessoa && this.card.pessoa.nome) {
        result = this.card.pessoa.nome
      }
      return result
    }
  },
  beforeMount () {
    this.onLoadLead()
  },
  created () {
    this.permissions = JWTService.GetRoles()
  },
  methods: {
    async onLoadAll () {
      await this.onLoadLead()
    },
    onLoadLead () {
      if (this.cardId) {
        loading.push()
        CardRepository.GetById(this.cardId)
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              this.card = response.data
              this.boardArchived = response.data.boardColumn.board.arquivado
              this.person = response.data.pessoa
              this.onLoadCardSyncDb(this.card)
            }
          })
          .catch((e) => {
            loading.pop()
            console.log(e.message)
          })
        this.$nextTick(() => {
          this.onReloadFollowup()
        })
      }
    },
    onLoadCardSyncDb (card) {
      if (card) {
        this.data.document = card.pessoa.document
        this.data.id = card.id
        this.data.boardColumnId = card.boardColumn ? card.boardColumn.id : null
        this.data.motivoPerdaId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = card.posicao
        this.data.situacao = card.situacao
        this.data.countReativado = card.countReativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
      }
    },
    onBack () {
      if (this.backUrl) {
        this.$router.push({ name: this.backUrl })
      } else {
        this.$router.push({ name: 'CRM' })
      }
    },
    onGain () {
      if (this.cardId) {
        loading.push()
        const gainData = {
          id: this.cardId,
          situacao: 'GANHO',
          dataInicioSituacao: new Date().toISOString()
        }
        BoardRepositoryV2.Card_PatchSituacao(
          this.card.boardColumn.board.id,
          this.card.boardColumn.id,
          this.cardId,
          gainData
        )
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.onLoadLead() // TODO: Nao precisa de reload. O back retorna o objeto alterado
              let description =
                'Definiu o Card de ' + this.personName + ' como ganho!'
              createNewFollowupWithCard(
                this.card.pessoa.document,
                'sys_oportunidade_ganha',
                description,
                this.ip,
                this.latitude,
                this.longitude,
                this.card.id
              )
            }
          })
          .catch((e) => {
            loading.pop()
            console.log(e.message)
          })
      }
    },
    onReactive () {
      if (this.cardId) {
        loading.push()
        const reativacaoData = {
          id: this.cardId,
          situacao: 'ATIVO',
          dataReativacao: new Date().toISOString()
        }
        BoardRepositoryV2.Card_PatchSituacao(
          this.card.boardColumn.board.id,
          this.card.boardColumn.id,
          this.cardId,
          reativacaoData
        )
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.onLoadLead() // TODO: Nao precisa de reload. O back retorna o objeto alterado
              let description =
                'Definiu o Card de ' + this.personName + ' como reativado!'
              createNewFollowupWithCard(
                this.card.pessoa.document,
                'sys_oportunidade_reativada',
                description,
                this.ip,
                this.latitude,
                this.longitude,
                this.card.id
              )
            }
          })
          .catch((e) => {
            loading.pop()
            console.log(e.message)
          })
      }
    },
    onLost () {
      this.$refs.ModalCardLost.showModal(this.card)
    },
    onFinish () {
      this.$refs.ModalCardFinish.showModal(this.card)
    },
    onConfirmDelete () {
      this.$refs.ModalCardDelete.showModal(this.card)
    },
    onReloadFollowup () {
      this.$refs.CrmDetailsTimeline.onSyncData()
    },
    onReloadChangeLeadOwner () {
      this.onReloadFollowup()
    },
    onReloadPersonAndFollowup () {
      this.onReloadFollowup()
      this.onLoadLead()
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/crmdetails.vue